module.exports = __webpack_public_path__ + "img/gd.63719ae5.svg";